import { useMediaQuery } from '@mui/material';

import { OptimizelyFeatureFlags } from '@tgg/common-types';

import { useFlagsContext, useTggTheme } from '../../../contexts';
import { Palette } from '../../../theme';
import { Icon } from '../../Icon';

import {
    HeaderWithIcon,
    StyledCloseButton,
    StyledHeadingHamBurger,
    StyledMenuHeader,
    StyledMenuIcon,
} from './Header.styled';
import { HeaderProperties } from './Header.types';

export function Header({
    id,
    icon,
    text,
    onClose,
    className,
}: HeaderProperties) {
    const { theme } = useTggTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));

    const {
        flags: {
            [OptimizelyFeatureFlags.REBRANDING]: { enabled: isRebrand },
        },
    } = useFlagsContext();

    return (
        <StyledMenuHeader id={id} className={className}>
            <HeaderWithIcon>
                <StyledHeadingHamBurger variant="h2" gutterBottom={false}>
                    {((isRebrand && icon === 'account') || !isRebrand) && (
                        <StyledMenuIcon
                            name={icon}
                            color={
                                !isRebrand
                                    ? (theme.palette.primary.main as Palette)
                                    : (theme.palette.tgg.icon.content
                                          .main as Palette)
                            }
                            size={isDesktop ? 26 : 22}
                        />
                    )}
                    {text}
                </StyledHeadingHamBurger>
            </HeaderWithIcon>
            <StyledCloseButton
                aria-label="close the side menu"
                onClick={onClose}
            >
                <Icon
                    name="close"
                    size={isRebrand ? 24 : 22}
                    color={
                        !isRebrand
                            ? (theme.palette.primary.main as Palette)
                            : (theme.palette.tgg.icon.action.main as Palette)
                    }
                />
            </StyledCloseButton>
        </StyledMenuHeader>
    );
}
